export const CATALOG_CACHE_KEY = "fas_catalog_cache_v1";
export const OFFLINE_SALES_KEY = "fas_pos_offline_sales";
export const FAILED_SALES_KEY = "fas_pos_failed_sales";

export function readCatalogCache() {
  try {
    const c = JSON.parse(localStorage.getItem(CATALOG_CACHE_KEY));
    return Array.isArray(c?.data) && c.data.length ? c.data : null;
  } catch { return null; }
}

export function writeCatalogCache(data) {
  try { localStorage.setItem(CATALOG_CACHE_KEY, JSON.stringify({ ts: Date.now(), data })); } catch {}
}

export function readQueue() {
  try { return JSON.parse(localStorage.getItem(OFFLINE_SALES_KEY)) || []; } catch { return []; }
}

export function writeQueue(q) {
  try { localStorage.setItem(OFFLINE_SALES_KEY, JSON.stringify(q)); } catch {}
}

export function pushFailedSale(sale) {
  try {
    const f = JSON.parse(localStorage.getItem(FAILED_SALES_KEY) || "[]");
    f.push({ ...sale, failed_at: new Date().toISOString() });
    localStorage.setItem(FAILED_SALES_KEY, JSON.stringify(f));
  } catch {}
}
